import React, { createContext, useEffect, useState } from "react";

import PropTypes from "prop-types";
import { get_app_data } from "../services";
import { message } from "antd";
import { isObjectEmpty } from "../utils/ObjectOperators";
import { format } from "date-fns/format";

const generalAppNoData = {
	exchangeRates: {
		gtq_usd: {
			general: 7.85
		}
	}
};

export const GeneralAppDataContext = createContext();

export const GeneralAppDataProvider = ({token, children}) => {
	const [generalAppData, setGeneralAppData] = useState(generalAppNoData);

	const checkGeneralAppData = async () => {
		const currentAppData = JSON.parse(localStorage.getItem("generalAppData")) || {};

		if (isObjectEmpty(currentAppData)) {
			await fetchGeneralAppData();
			return;
		}

		const { date } = currentAppData;
		const currentDate = new Date();
		const formattedDate = format(currentDate, "dd/MM/yyyy");

		if (date === formattedDate) {
			setGeneralAppData(currentAppData.currency);
			return;
		}

		await fetchGeneralAppData();
	};

	useEffect(() => {
		if (typeof token !== "string") return;

		checkGeneralAppData();
	}, [token]);

	const fetchGeneralAppData = async () => {
		const resp = await get_app_data(token);

		if (resp?.currency) {
			setGeneralAppData(resp.currency);
			localStorage.setItem("generalAppData", JSON.stringify(resp) || {});
			//message.success("Nueva Data General cargada con éxito");
			return;
		}

		message.error(resp);
	};
	
	return (
		<GeneralAppDataContext.Provider value={{ generalAppData }}>
			{children}
		</GeneralAppDataContext.Provider>
	);
};

GeneralAppDataProvider.propTypes = {
	token: PropTypes.any.isRequired,
	children: PropTypes.node.isRequired,
};